import { useApiComputerAnalyticsVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useApiComputerAnalyticsVariation.js';
import { useAPIGroupSettingsEnabled } from '#pplx/frontend/apps/ask/organization/hooks/useAPIGroupSettingsEnabled.js';
import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
import { useIsOrgAdmin } from '#pplx/frontend/apps/ask/organization/hooks/useIsOrgAdmin.js';
import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useBooleanFlagValue } from '#pplx/frontend/experimentation/hooks.js';
export function useEnterpriseApiSettingsPermissions() {
    const { variation: isAnalyticsApiEnabled, loading: analyticsApiLoading } = useApiComputerAnalyticsVariation({
        defaultValue: false,
    });
    const { variation: isAdminApiKeysEnabled, loading: adminApiKeysLoading } = useBooleanFlagValue({
        flag: 'enterprise-admin-api-ui',
        defaultValue: false,
    });
    const isEnterprise = useIsEnterpriseUser();
    const isAdmin = useIsOrgAdmin();
    const { permissions, isLoading: permissionsLoading } = useEffectivePermissions({
        reason: 'useEnterpriseApiSettingsPermissions',
        enabled: isEnterprise && isAdminApiKeysEnabled,
    });
    const { value: hasApiAccess, loading: apiAccessLoading } = useAPIGroupSettingsEnabled();
    const { status } = useSession();
    if (analyticsApiLoading ||
        adminApiKeysLoading ||
        status === 'loading' ||
        (isEnterprise && isAdminApiKeysEnabled && (permissionsLoading || apiAccessLoading))) {
        return {
            canManageAnalyticsApi: false,
            canManageAuditLogApi: false,
            isLoading: true,
        };
    }
    return {
        // Analytics management still requires the org-admin role.
        canManageAnalyticsApi: isAnalyticsApiEnabled && isEnterprise && isAdmin,
        canManageAuditLogApi: isAdminApiKeysEnabled &&
            isEnterprise &&
            permissions.has('org_audit_logs_read') &&
            hasApiAccess,
        isLoading: false,
    };
}
//# sourceMappingURL=useEnterpriseApiSettingsPermissions.js.map